module.exports = __webpack_public_path__ + "static/media/spinner_dec.519ba00a.webp";